import { Environment } from "./environment.interface";

export const environment: Environment = {
  production: true,
  name: "production",
  release: "1.8.5#40337466225",
  dist: "<$dist>",
  apiUrl: "https://api.visor.riscbal.uib.cat",
};
